import { Component, EventEmitter, Output } from '@angular/core';
// import { ErrorService } from 'src/app/services/error.service';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
    selector: 'app-login-register',
    templateUrl: './login-register.component.html',
    styleUrls: ['./login-register.component.scss'],
    standalone: false
})
export class LoginRegisterComponent {
  @Output() signInClickEvent = new EventEmitter<string>();
  @Output() continueClickEvent = new EventEmitter<void>();
  // Todo: Tim: #mar25 - this component is no longer necessary and should be cleaned up/removed

  constructor(
    public firebaseService: FirebaseService,
  ) {}

  handleLogin() {
    this.signInClickEvent.emit('login');
  }

  handleRegister() {
    this.signInClickEvent.emit('register');
  }

  continueWithoutLogIn() {
    this.continueClickEvent.emit();
  }
}
